<vm-which-tv-box *ngIf="isLoaded" [content]="content" [workflowName]="workflowName" [actionCode]="actionCode"></vm-which-tv-box>
